import { useEffect } from "react";

import { Spinner, Text } from "@alpacahq/ui/old";

import { Footer } from "~/v2/components/common/footer";
import { withAppBasePath } from "~/v2/utils/appBasePath";
import { Path } from "../../../path";
import App from "../../index";
import { useSession } from "./session";
import { Progress } from "./wizard";

const Onboarding = () => {
  const session = useSession();
  const name = session.account?.name?.split(" ").at(0) ?? "";
  const isAccountTypeStep = session?.milestone === 1;
  const isReady = session.ready && !!session.step;

  useEffect(() => {
    if (session?.account?.last_onboarding_step === "finished") {
      window.location.href = withAppBasePath(Path.ROUTE_DASHBOARD);
    }
    if (session?.isLegalEntity) {
      window.location.href = withAppBasePath(
        Path.ROUTE_ENTITY_ONBOARDING_BUSINESS_INFO,
      );
    }
  }, [session?.account, session?.isLegalEntity]);

  return (
    <App>
      {!isReady ? (
        <div className="mt-16 mb-96 flex items-center justify-center">
          <Spinner />
        </div>
      ) : isAccountTypeStep ? (
        <session.step.component session={session} />
      ) : (
        <div className="p-4 md:p-0">
          <div>
            <h2 className="text-lg">
              Welcome to Alpaca{name ? `, ${name}` : ""}!
            </h2>
            <Text className="opacity-60">
              Create your Alpaca Live Trading account in just a few minutes.
            </Text>
          </div>
          <div className="flex h-full flex-col md:flex-row">
            <div className="mr-8 pt-16">
              <Progress
                reached={session.milestone}
                steps={session.visibleSteps}
              />
            </div>
            <div className="grow pt-16">
              <session.step.component session={session} />
            </div>
          </div>
        </div>
      )}
      <Footer noFadeUp={true} legal={true} />
    </App>
  );
};

export default Onboarding;
